const ThemeConfig = {
    dark: {
        title: 'Dark Mode',
        description: 'Use dark theme for reduced eye strain.',
        icon: 'darkMode' as const,
    },
    light: {
        title: 'Light Mode',
        description: 'Use light theme for high visibility.',
        icon: 'lightMode' as const,
    },
    system: {
        title: 'System Default',
        description: 'Follow your device settings.',
        icon: 'systemDefault' as const,
    },
} as const

export const themeOptions = [
    {
        value: 'dark' as const,
        ...ThemeConfig.dark,
    },
    {
        value: 'light' as const,
        ...ThemeConfig.light,
    },
    {
        value: 'system' as const,
        ...ThemeConfig.system,
    },
]
